module.exports = __webpack_public_path__ + "static/media/domain_logo_Texas.49ea2440.svg";